import { mobile } from "../../../mediaQueries";

const styles = (theme) => ({
  root: {
    width: "100%",
    margin: "auto",
    height: "auto",
    opacity: 0,
    transition: "opacity 2.5s cubic-bezier(.4,.28,0,1.03)",
    aspectRatio: "1124/632",
    overflow: "hidden",
    maxWidth: "1150px",
    position: "relative",
    boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.2)",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      marginTop: "30px",
      height: "450px",
    },
  },
  img: {
    width: "100%",
    height: "100%",
    transform: (props) => `scale(${props.zoomedIn ? 1.5 : 1})`,
    transition: "transform 1.3s",
    transformOrigin: "top",
    marginBottom: "-10px",
    [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
      height: "450px",
      objectFit: "cover",
    },
  },
  button: {
    cursor: "none !important",
    position: "absolute",
    backgroundColor: "#0045EA",
    color: "white",
    transition: "all 0.3s",
    padding: "12px 20px",
    fontFamily: "Aktiv Grotesk",
    borderRadius: 0,
    letterSpacing: "0.01em !important",
    fontSize: "14px",
    zIndex: 90,
    textTransform: "none",
    fontWeight: "500",
    whiteSpace: "nowrap",
    lineHeight: "16px",
    bottom: "2.5rem",
    left: "50%",
    transform: "translateX(-50%)",
    "&:hover": {
      backgroundColor: "#0045EA",
    },
  },
  mobileBtn: {
    cursor: "none !important",
    backgroundColor: "#0045EA",
    color: "white",
    padding: "12px 20px",
    transition: "all 0.3s",
    fontFamily: "Aktiv Grotesk",
    whiteSpace: "nowrap",
    borderRadius: 0,
    letterSpacing: "0.01em !important",
    fontSize: "14px",
    textTransform: "none",
    fontWeight: "500",
    lineHeight: "16px",
    "&:hover": {
      backgroundColor: "#0045EA",
    },
    width: "fit-content",
    margin: "auto",
    marginTop: "30px",
  },
});

export default styles;
